import React, { useContext, useState } from 'react';
import { Switch, Typography } from 'antd';
import { IoCarSport, IoCarSportOutline } from 'react-icons/io5';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const VehicleStartStopAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [isStarted, setIsStarted] = useState(true);
  const [loading, setLoading] = useState(false);

  const triggerVehicleAlert = async () => {
    setLoading(true);
    await triggerAlert({ serialNo, vehicleKey, actual: '', threshold: '' }, credentials, ALERT_CATEGORY.VEHICLE_START_STOP_ALERT)
      .then(() => { messageApi.success('Vehicle start/stop alert triggered successfully'); onTriggered?.({ success: true, value: isStarted ? 'Vehicle Started' : 'Vehicle Stopped' }); })
      .catch(() => { messageApi.error('Failed to trigger vehicle start/stop alert'); onTriggered?.({ success: false, value: isStarted ? 'Vehicle Started' : 'Vehicle Stopped' }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={7}
      title="Vehicle Start / Stop"
      icon={isStarted ? <IoCarSport /> : <IoCarSportOutline />}
      iconBg={isStarted ? '#f0fdf4' : '#f8fafc'}
      iconColor={isStarted ? '#059669' : '#94a3b8'}
      onTrigger={triggerVehicleAlert}
      triggerLabel="Trigger Start/Stop Alert"
      loading={loading}
    >
      <Text style={{ fontSize: 11, color: '#64748b' }}>Simulated vehicle state</Text>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 12px',
          borderRadius: 8,
          background: isStarted ? '#f0fdf4' : '#f8fafc',
          border: `1px solid ${isStarted ? '#86efac' : '#e2e8f0'}`,
          transition: 'all 0.2s',
        }}
      >
        <Text style={{ fontSize: 12, fontWeight: 600, color: isStarted ? '#166534' : '#64748b' }}>
          {isStarted ? 'Vehicle Started' : 'Vehicle Stopped'}
        </Text>
        <Switch
          checked={isStarted}
          onChange={setIsStarted}
          checkedChildren="ON"
          unCheckedChildren="OFF"
        />
      </div>
    </AlertCard>
  );
};

export default VehicleStartStopAlert;
